module.exports = __webpack_public_path__ + "img/fastcharger-request.939dffc5.svg";